import router from "@/router";
import uiThemeConfig from "@/ui-theme";
import {writeDistIDToDixie, readDistIDFromDixie} from '@/dexie/distId.js';



// IMPORTS
const _ = require('lodash');
const axios = require('axios');

// DEFINITIONS
const baseAPI = 'ui/loadup';

interface State {
    distId: number | null;
    theme: object;
    msisdn: any[];
    usuariodn: object;
}
const state: State = {
    distId: null,
    theme: {},
    msisdn: [],
    usuariodn: {}
};

const getters = {
    uiGetDistId: (state: State) => {
        return state.distId;
    },
    uiGetTheme: (state: State) => {
        return state.theme;
    },
    uiGetMsisdnCfg: (state: State) => {
        return state.msisdn;
    },
    uiGetUsuariodn: (state: State) => {
        return state.usuariodn;
    },
};

const mutations = {
    uiSetDistId: (state: State, payload: number) => {
        state.distId = payload;
    },
    uiFreeDistId: (state: State) => {
        state.distId = null;
    },
    uiSetTheme: (state: State, payload: any) => {
        state.theme = payload;
    },
    uiSetMsisdn: (state: State, payload: any) => {
        state.msisdn = payload;
    },
    uiSetUsuariodn: (state: State, payload: any) => {
        state.usuariodn = payload;
    }
};

const actions = {
    uiReadDistIDFromDixie: async ({ commit }: any) => {
        try {
            const distId = await readDistIDFromDixie();
            if (distId) {
                commit('uiSetDistId', distId);
                console.log("uiReadDistIDFromDixie.success", distId);
                return distId;
            } else {
                console.log("uiReadDistIDFromDixie.noDistIdFound");
                return null;
            }
        } catch (e: any) {
            console.error("uiReadDistIDFromDixie.error", e);
            return null;
        }
    },
    uiLoadUp: async ({ commit }: any, args: any) => {
        try {
            const msisdn = (args.msisdn) ? args.msisdn : null;
            if (msisdn && !/^[\d\-\(\)]+$/.test(msisdn)) 
                throw ('El MSISDN solo debe contener números, paréntesis o guiones');
            const iccid = (args.iccid) ? args.iccid : null,
                url = (baseAPI + "/" + msisdn + '/' + iccid),
                response = await axios.get(url);

            // Establecimiento de MSISDN y Usuariodn
            commit('uiSetMsisdn', response.data.msisdn)
            commit('uiSetUsuariodn', response.data.usuariodn)

            // Configuración de teman en uiThemeConfig, si viene vacío restaura automáticamente a los valores por defecto.
            uiThemeConfig.setUiDistValues(response.data.dist)

            // Configuración de distribuidor para bypass heredado y ID de distribuidor.
            if(response.data.dist){

                // Establece el ID de distribuidor en el estado, lo que puede ser utilizado por otros componentes 
                // o módulos para determinar el contexto del distribuidor.
                commit('uiSetDistId', response.data.dist.id);
                
                // Evalúa el comportamiento de bypass heredado, si es 1 se establece el bypass heredado, 
                // de lo contrario se desactiva.
                if(parseInt(response.data.dist.bypassInherited) === 1) {
                    commit('uiSetInheritBypass');
                } else {
                    commit('unsetInheritBypass');
                }

                writeDistIDToDixie(response.data.dist.id);
            } else {
                commit('uiFreeDistId');
                commit('unsetInheritBypass');
                writeDistIDToDixie(null);
            }
            
        } catch (e) {
            router.push({ name: 'home' });
            commit('unsetInheritBypass');
            console.error(e);
        } finally {
            const themeUpdate = { accentColor: '#fa8100', alternateColor: '#0090de' };
            console.log('settingTheme', themeUpdate)
            console.log('uiThemeConfig before update', uiThemeConfig)
        }
    },
};

// EXPORTS
export default {
    state,
    getters,
    mutations,
    actions,
};